<div [style.width]="width">
  <p-treeSelect
    [(ngModel)]="innerModel"
    [options]="treeNodes"
    [placeholder]="placeholder"
    [appendTo]="appendTo"
    panelStyleClass="msf-tree-select-panel"
    (ngModelChange)="onSelectItem()"
    [filter]="true"
    [filterPlaceholder]="'Search' | translate"
    [showClear]="showClear"
    [loading]="loading"
    (onClear)="innerModel = null; onSelectItem()"
    [metaKeySelection]="false"
    [selectionMode]="'single'"
  ></p-treeSelect>
</div>
